import type { IconNode } from '../types';

/**
 * @name bottle-perfume
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iNCIgeD0iNiIgeT0iMyIgLz4KICA8cmVjdCB3aWR0aD0iNiIgaGVpZ2h0PSI0IiB4PSI5IiB5PSI3IiAvPgogIDxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxMCIgeD0iMyIgeT0iMTEiIHJ4PSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bottle-perfume
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottlePerfume: IconNode = [
  ['rect', { width: '12', height: '4', x: '6', y: '3', key: 'bdw6vj' }],
  ['rect', { width: '6', height: '4', x: '9', y: '7', key: '5lqhht' }],
  ['rect', { width: '18', height: '10', x: '3', y: '11', rx: '2', key: '1ofdy3' }],
];

export default bottlePerfume;
